import { useEffect, useState, useRef } from 'react'
import { PlusIcon, MinusIcon } from '@heroicons/react/24/outline'

export default ({ 
  label,
  individualLabel,
  fieldArrayProps,
  validator = {},
  className = 'w-full',
  inputProps = {},
  displayHelperText = true
}) => {
  const { fields, append, remove } = fieldArrayProps
  const [fileNames, setFileNames] = useState([])
  const fileInputRef = useRef(null)
  const initializedRef = useRef(false)

  // Effet pour initialiser fileNames avec les fields existants
  useEffect(() => {
    if (fields.length > 0 && !initializedRef.current) {
      setFileNames(fields.map(f => f.filename || ''))
      initializedRef.current = true
    }
  }, [fields])

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files)
    if (files.length > 0) {
      // Ajouter chaque fichier au tableau
      files.forEach(file => {
        append(file)
      })
      
      // Mettre à jour les noms de fichiers pour l'affichage
      setFileNames(prev => [...prev, ...files.map(file => file.name)])
      
      // Réinitialiser l'input pour permettre la sélection des mêmes fichiers
      e.target.value = null
    }
  }

  const helperAcceptedFiles = () => {
    const acceptTypes = {
      'pdf': "seulement des fichiers PDF.",
      'image\/': "seulement des fichiers image.",
      'video\/': "seulement des fichiers vidéo.",
      'audio\/': "seulement des fichiers audio.",
      'text\/': "seulement des fichiers texte."
    }
                    
    for (const [pattern, message] of Object.entries(acceptTypes)) {
      if (inputProps.accept && inputProps.accept.match && inputProps.accept.match(pattern)) {
        return message
      }
    }
    
    return inputProps.accept ? `Formats acceptés : ${inputProps.accept}` : ''
  }

  return (
    <div className={`${className} space-y-4`}>
      <div className="flex flex-wrap items-end gap-2">
        <div className='flex flex-col w-full space-y-2'>
          {/* Liste des fichiers sélectionnés */}
          {fields.length > 0 && fields.map((field, index) => (
            <div className="flex" key={field.id}>
            <label className="input min-w-[300px]">
              <span className="label">{`${individualLabel} ${index + 1}`}</span>
              <div className="w-full overflow-hidden -ml-2 pr-2">
                <span className="truncate block text-base-content/70 cursor-pointer hover:text-primary transition-colors">
                  {field.filename || fileNames[index]}
                </span>
              </div>
            </label>
            <button 
              type="button"
              className="btn btn-circle btn-xs btn-ghost bg-neutral-content hover:bg-warning mt-2 ml-2"
              onClick={() => {
                remove(index)
                setFileNames(prev => prev.filter((_, i) => i !== index))
              }}
              title="Supprimer ce fichier"
            >
              <MinusIcon className="h-4 w-4" />
            </button>
            </div>
          ))}

          <div className="flex flex-col justify-center">
            <label className={`btn btn-sm btn-primary text-white ${validator.hasError ? 'validator' : ''} mt-2`}
              {...(validator.hasError && validator.hasError('photos') ? {'aria-invalid': true} : {})}
            >
              <PlusIcon className="h-5 w-5 mr-1"/> Ajouter une ou plusieurs {label.toLowerCase()}
              <input
                type="file"
                className="hidden"
                ref={fileInputRef}
                {...inputProps} 
                multiple={true}
                onChange={handleFileChange}
              />
            </label>
            {validator.getErrorMessage && (
              <div className="validator-hint hidden empty:py-[0.6rem] mb-2">
                {validator.getErrorMessage('photos')}
              </div>
            )}
            <label className="label text-sm mx-auto">
              { displayHelperText && <span className="text-sm">
                {helperAcceptedFiles()}
              </span>}
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}